import React from "react"

import Box from '@mui/material/Box'

import cssVars from "app/helpers/_variables.module.scss";
import './AppCircle.scss'

export default function AppCircle({content, size, background, color,addClass, onMouseEnterFunc, onMouseLeaveFunc, onClickFunc, border=""}){

  return (
    <Box 

      onClick={onClickFunc}
      sx={{
        width: size,
        height: size,
        minWidth: size,
        bgcolor: cssVars[background]||background,
        color: cssVars[color],
        border: border
        }}
        
      className={`app-circle ${addClass}`}

       >
      {content}
    </Box>
    );

}